import React, { FC } from 'react';
import { PaddingBox } from '../../../../../../ReactSharedScripts/components/PaddingBox';

type StaticHeaderLayoutKeyIndicatorsProps = {
	className?: string;
};

export const StaticHeaderLayoutKeyIndicators: FC<React.PropsWithChildren<StaticHeaderLayoutKeyIndicatorsProps>> = ({
	children,
	className,
}) => {
	return (
		<PaddingBox
			hrMedium
			className={className}
		>
			{children}
		</PaddingBox>
	);
};
